import axios from 'axios';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

const AddProducts = () => {
  // create hooks to get products in backend

  const [product_name,setProductName]=useState('');
  const [product_description,setProductDescription]=useState('');
  const[product_cost,setProductCost]=useState('');
  const[product_photo,setProductPhoto]=useState('');

  const [loading,setLoading]=useState('');
  const [success,setSuccess] = useState('');
  const [error,setError] = useState('');

  const navigate = useNavigate();

  const handleSubmit =async (e)=>{
    e.preventDefault();
    setLoading('Loading...')
    try {
      // create new empty object formdata
      const formData = new FormData();
      formData.append('product_name',product_name)
      formData.append('product_description',product_description)
      formData.append("product_cost",product_cost);
      formData.append("product_photo",product_photo);
      // posting data in api
      const response =await axios.post('https://40b.pythonanywhere.com/api/add_product',formData)
      setLoading('')
      if(response.data.message){
        setLoading('')
        setSuccess(response.data.message)
        setProductName('')
        setProductDescription('')
        setProductCost('')
        setProductPhoto('')
        navigate('/')
        
      }
      
    } catch (error) {
      setLoading('')
      setSuccess('')
      setError(error.message)
      
    }

  }
  return (
    <div className='row justify-content-center mt-4'>
      <div className='shadow card col-md-6 p-4'>
        <h1>Add products</h1>
        {loading}
        {success}
        {error}
          <form action="" onSubmit={handleSubmit}>
            <input type="text" className='form-control' 
            placeholder="Product Name" 
            value={product_name}
            onChange={(e)=>{setProductName(e.target.value)}}/> <br />
            <textarea name="" id="" className='form-control' 
            placeholder="Product Description"
            value={product_description}
            onChange={(e)=>{setProductDescription(e.target.value)}}></textarea>
            <br />
            <input type="number" className='form-control' 
            placeholder="Enter Price"
            value={product_cost}
            onChange={(e)=>{setProductCost(e.target.value)}} /> <br />
            <input type="file" className='form-control' 
            placeholder="Product Photo"
            onChange={(e)=>{setProductPhoto(e.target.files[0])}} /> <br />
            <button type='submit' className='btn btn-primary'>Add Product</button>
          </form>
      </div>
    </div>
  );
}

export default AddProducts